<template>
  <div>
    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div class="page-wrapper">
      <!-- ============================================================== -->
      <!-- Container fluid  -->
      <!-- ============================================================== -->
      <div class="container-fluid">
        <!-- ============================================================== -->
        <!-- Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <div class="row page-titles">
          <div class="col-md-5 align-self-center">
            <h4 class="text-themecolor">Audit Log</h4>
          </div>
          <div class="col-md-7 align-self-center text-right">
            <div class="d-flex justify-content-end align-items-center">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li class="breadcrumb-item active">Audit Log</li>
              </ol>
            </div>
          </div>
        </div>

        <div class="row justify-content-end">
          <div class="col-sm-4">
            <label class="boldText">Users</label>
            <Multiselect
              v-model="selectedUsersId"
              mode="tags"
              :searchable="true"
              :createTag="true"
              :options="usersList"
            />
          </div>
          <div class="col-sm-4">
            <label class="boldText">Sections</label>
            <Multiselect
              v-model="selectedAppModelsId"
              mode="tags"
              :searchable="true"
              :createTag="true"
              :options="appModelsList"
            />
          </div>
          <div class="col-sm-4">
            <label class="boldText">Select Date</label>
            <div class="input-group mb-3">
              <input type="date" class="form-control" v-model="filterDate" />
              <div class="input-group-append"></div>
            </div>
          </div>
        </div>

        <div class="row" v-for="(act, ndx) in actionsFiltered" :key="ndx">
          <div
            class="col-12"
            v-for="(dt, ndx01) in act.actionDates"
            :key="ndx01"
          >
            <div class="card">
              <div class="card-body">
                <ul class="timeline">
                  <li
                    v-for="(actType, ndx02) in dt.actionTypes"
                    :key="ndx02"
                    :class="ndx01 % 2 == 0 ? '' : 'timeline-inverted'"
                  >
                    <div class="timeline-badge warning">
                      <img
                        :src="getIcon(actType.actionTypeId)"
                        alt=""
                        style="height: 20px; margin: 16px"
                      />
                    </div>
                    <div class="timeline-panel">
                      <div class="row">
                        <div class="col-8">
                          <div class="timeline-heading">
                            <p
                              class="timeline-title"
                              style="font-size: 20px; font-weight: 800"
                            >
                              {{ actType.actionTypeName }} <br /><small
                                class="text-muted"
                                >{{ actType.appModelName }}</small
                              >
                            </p>
                          </div>
                        </div>
                        <div class="col-4">
                          <h4 class="timeline-title">{{ act.actionToName }}</h4>
                          <p>
                            <small class="text-muted">
                              <i class="fa fa-clock-o"></i
                              >{{ dateToLocalString(dt.actionDate) }}
                            </small>
                          </p>
                        </div>
                      </div>
                      <div class="timeline-body">
                        <p
                          v-for="(msg, ndx03) in actType.actionMessages"
                          :key="ndx03"
                        >
                          {{ msg }}
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- ============================================================== -->
      </div>
      <!-- ============================================================== -->
      <!-- End Container fluid  -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Page wrapper  -->
    <!-- ============================================================== -->
  </div>
</template>

<script>
import axios from "axios";
import Multiselect from "@vueform/multiselect";

export default {
  name: "AuditLog",
  components: {
    Multiselect,
  },

  data() {
    return {
      //loader
      loader: "",
      //Timer
      TimerObject: {},
      actionsFiltered: [],
      actionsRaw: [],
      dummy: [],

      selectedAppModelsId: [],
      appModelsList: [],
      selectedUsersId: [],
      usersList: [],

      filterDate: "",
    };
  }, //data

  methods: {
   loader_1() {
     this.loader = this.$loading.show({
            // Optional parameters
              color: '#03a9f3'
            });
   },

    //Timer
   StartLogoutTime() {
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    ResetLogoutTime() {
      clearTimeout(this.TimerObject);
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    
    getIcon(id) {
      //console.log(id);
      if (id == 100) return "assets/images/actions/comment.png";
      else if (id == 50) return "assets/images/actions/edit.png";
      else if (id == 51) return "assets/images/actions/sent.png";
      else if (id == 300) return "assets/images/actions/credit-card.png";
      else if (id == 302) return "assets/images/actions/stethoscope.png";
      else if (id == 303) return "assets/images/actions/stethoscope.png";
      else if (id == 201) return "assets/images/actions/mapping.png";
      else if (id == 301) return "assets/images/actions/cash-money.png";
      else if (id == 400) return "assets/images/actions/steps1.png";
      else if (id == 304) return "assets/images/actions/patient.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 50) return "assets/images/actions/edit.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 50) return "assets/images/actions/edit.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 50) return "assets/images/actions/edit.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 50) return "assets/images/actions/edit.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 50) return "assets/images/actions/edit.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
    },

    getFilterData() {
      this.intDummyComm();
      this.dummyComm.myDate = this.filterDate;
      this.dummyComm.extras = this.selectedUsersId.join();
      this.dummyComm.extras1 = this.selectedAppModelsId.join();

      const url = this.SERVER + "/VNSPRAAPI/actionlog/GetInitData";

      this.axiosGetData(url, 2);
    },

    loadInit() {
      this.intDummyComm();
      this.dummyComm.myDate = "";

      const url = this.SERVER + "/VNSPRAAPI/actionlog/GetInitData";

      this.loader_1();
      this.axiosGetData(url, 1);
      this.StartLogoutTime();
    },

    //------------------------------------------ Common Methods
    async axiosGetData(myUrl, what) {
      await axios({
        method: "post",
        url: myUrl,
        data: this.dummyComm,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          // if everything goes well -- we will get data
          if (what === 1) {
            this.loader.hide();
            if (res.status === 200) {
           //debugger// eslint-disable-line no-debugger
              //console.log(res.data);
              this.dummy = res.data;
              this.actionsFiltered = res.data.visitHist;
              //this.actionsRaw = res.data.visitHist;
              this.usersList = res.data.users;
              this.appModelsList = res.data.appModels;
            }
          } else if (what === 2) {
            if (res.status === 200) {
              //console.log(res.data);
              this.dummy = res.data;
              this.actionsFiltered = res.data.visitHist;
            }
          }
        })
        .catch(function (error) {
          if (error.response) {
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            this.lastErrorCode = 1;
            alert("No response " + error.request);
          } else {
            alert("Error", error.message);
          }
        })
        .finally(() => {this.ResetLogoutTime();});
    }, // axiosGetData
  }, // methods

  mounted() {
    clearTimeout(this.loadObj);
    this.loadInit();
  }, // mounted
unmounted() {
      clearTimeout(this.TimerObject);
    },
  watch: {
    selectedUsersId: function () {
      this.getFilterData();
    },
    selectedAppModelsId: function () {
      this.getFilterData();
    },
    filterDate: function () {
      this.getFilterData();
    },
  },
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
<style>
</style>